import _ from 'lodash';
export var E_BoolEx;
(function (E_BoolEx) {
    E_BoolEx["NONE"] = "_none";
    E_BoolEx["TRUE"] = "true";
    E_BoolEx["FALSE"] = "false";
    E_BoolEx["ALL"] = "_all";
})(E_BoolEx || (E_BoolEx = {}));
export var BooleanEx;
(function (BooleanEx) {
    function fromBool(b) {
        if (_.isNil(b)) {
            return E_BoolEx.NONE;
        }
        if (b) {
            return E_BoolEx.TRUE;
        }
        else {
            return E_BoolEx.FALSE;
        }
    }
    BooleanEx.fromBool = fromBool;
    function toBool(b) {
        if (b === E_BoolEx.TRUE) {
            return true;
        }
        if (b === E_BoolEx.FALSE) {
            return false;
        }
        return undefined;
    }
    BooleanEx.toBool = toBool;
    function fromValue(b) {
        if (_.isNil(b) || b === E_BoolEx.NONE) {
            return undefined;
        }
        return b;
    }
    BooleanEx.fromValue = fromValue;
})(BooleanEx || (BooleanEx = {}));
